(() => {
  // app/scripts/all-designers.js
  if (!customElements.get("load-more-button")) {
    class LoadMoreButton extends HTMLButtonElement {
      constructor() {
        super();
        this.addEventListener("click", this.handleClickEvent.bind(this));
      }
      handleClickEvent() {
        this.setAttribute("disabled", "disabled");
        this.classList.add("loading");
        let totalPages = parseInt(this.dataset.totalPages);
        const currentPage = parseInt(this.dataset.currentPage);
        const nextPageUrl = this.dataset.nextUrl;
        fetch(nextPageUrl).then((response) => response.text()).then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
          const list = parsedHTML.querySelectorAll(".js-designers-list li");
          document.querySelector(".js-designers-list").append(...list);
          this.dataset.currentPage = currentPage + 1;
          if (this.dataset.currentPage != totalPages) {
            this.dataset.nextUrl = parsedHTML.querySelector(".js-load-more").dataset.nextUrl;
            if (this.enabledCR2) {
              this.dataset.nextUrl += "&use_cr2=true";
            } else {
            }
          } else {
            if (this.hasAttribute("data-cr2-page-param") && !this.dataset.nextUrl.includes("use_cr2")) {
              const newNextUrl = this.dataset.nextUrl.split("?")[0] + "?" + this.getAttribute("data-cr2-page-param") + "=1&use_cr2=true";
              this.dataset.nextUrl = newNextUrl;
              this.dataset.currentPage = 0;
              this.dataset.totalPages = totalPages = +this.getAttribute("data-cr2-total-pages");
              this.enabledCR2 = true;
            }
          }
          if (this.closest("carousel-slider")) {
            const slider = this.closest("carousel-slider");
            slider.slides = slider.querySelectorAll(".slider__item");
            slider.removeListeners();
            slider.initSlider();
          }
        }).finally(() => {
          this.removeAttribute("disabled");
          this.classList.remove("loading");
          if (this.dataset.currentPage == totalPages) {
            this.classList.add("hidden");
          }
        });
      }
    }
    customElements.define("load-more-button", LoadMoreButton, { extends: "button" });
  }
})();
